import React from "react";

export const ToasterMobileHandleIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8.95"
    height="26.502"
    viewBox="0 0 8.95 26.502"
    {...props}
  >
    <path
      d="M-5481.441,1767.642l-4.187,11.229,4.187,10.087"
      transform="translate(5487.777 -1765.069)"
      fill="none"
      stroke="#707070"
      strokeLinecap="round"
      strokeWidth="4"
    />
  </svg>
);

export const ToasterCloseActionIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path
      d="M15.636,13.415l7.778-7.778,2.222,2.222-7.778,7.778,7.778,7.778-2.222,2.222-7.778-7.778L7.858,25.637,5.636,23.414l7.778-7.778L5.636,7.859,7.858,5.637Z"
      transform="translate(-5.636 -5.637)"
      fill="#596970"
    />
  </svg>
);
